import React, { useState, useEffect, useRef } from 'react';

const LazyImage = ({ className, src, alt, lowQualitySrc }) => {
  const [loaded, setLoaded] = useState(false);
  const [imageSrc, setImageSrc] = useState(lowQualitySrc);
  const isMountedRef = useRef(true);

  useEffect(() => {
    const image = new Image();
    image.src = src;
    image.onload = () => {
      if (isMountedRef.current) {
        setLoaded(true);
      }
    };

    return () => {
      // Clean up the image object if the component is unmounted before the image loads
      isMountedRef.current = false;
      image.onload = null;
    };
  }, [src]);

  useEffect(() => {
    if (loaded) {
      setImageSrc(src);
    }
  }, [loaded, src]);

  return <img itemProp="thumbnailUrl" className={className} src={imageSrc} alt="" />;
};

export default LazyImage;